module.exports = __webpack_public_path__ + "static/media/scroll-up.a04be8af.svg";